import './index.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';

import { InspectorControls } from '@wordpress/block-editor';
import {	
	PanelBody,	
	RangeControl,
	ToggleControl,
	Flex, 
	FlexItem,
	ButtonGroup,
	Button
} from '@wordpress/components';


const allowedBlocks = [ 'core/columns' ];
const acolumnsDefaults = {
	aOn: false,
	columnsList: ['', '', '', ''], // [lg, md, sm, ssm]	
}


const addAttributes = ( settings, name ) => {		

	if (!allowedBlocks.includes(name)) return settings;	

	if( typeof settings.attributes !== 'undefined' ){	
		settings.attributes = {
      ...settings.attributes,		
			acolumns: {
				type: 'object',
				default: acolumnsDefaults,
			}		
		}   
	}
	return settings;
}


const addInspectorControl = (BlockEdit) => (props) => {

	if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const {	attributes, setAttributes, isSelected } = props;
	const { acolumns = {}, isStackedOnMobile } = attributes;

  const orgDefaults = {
		...acolumnsDefaults,
		...(attributes.acolumns || {}),
	}

	const { 
		aOn, 
		columnsList
	} = orgDefaults;

	const isDifferentFromDefault = JSON.stringify({ ...acolumns, aOn: undefined }) !== JSON.stringify({ ...acolumnsDefaults, aOn: undefined });
	
	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray =( list, index, newval ) =>{		
		const listsCopy = [ ...list ];					
		listsCopy[ index ] = newval;		
		return listsCopy;			
	}

	const reset = () => {
		setAttributes({ 
			acolumns: { 
				...acolumns, 
				columnsList: ['', '', '', ''] 
			} 
		});			
	}

	const [syncViewport, setSyncViewport] = useState(false);
	const [breakPoint, setBreakPoint] = useState(0);

	useEffect(() => {
		const update = () => {
			let temp = 'Desktop';
			if (breakPoint === 1) temp = 'Tablet';
			if (breakPoint === 2) temp = 'Mobile';
			if (breakPoint === 3) temp = 'Mobile'; // SSmall Screen
			if (syncViewport) wp.data.dispatch('core/editor').setDeviceType(temp);
		};
		update();
	}, [syncViewport, breakPoint]);

	

	
	return (
		<>
			<BlockEdit { ...props } />		
			<InspectorControls group="settings">   
			
				
					<PanelBody title={__('Column Setting', 'aver')} initialOpen={aOn}>			

				
						<Flex>
							<FlexItem>
								<ToggleControl
									label={__('Enable Columns', 'aver')}
									checked={aOn}
									onChange={(val) => setAttributes({ acolumns: {...acolumns, aOn: val }})}
								/>
							</FlexItem>
							<FlexItem>
								{ isDifferentFromDefault && (
									<ResetAttributes
										onConfirm={() => {
											setAttributes({
												acolumns: acolumnsDefaults
											});								
										}}
									/> 
								)}
							</FlexItem>
						</Flex>			
					
					
					{ aOn && <>			
						

						<Flex style={{margin: "1rem 0" }}>
							<FlexItem className="button-frame">
								<Button icon="welcome-view-site" label="Sync Viewport" onClick={() => setSyncViewport(!syncViewport)}	isPressed={syncViewport} />
								<Button icon="undo"	label="Reset All"	onClick={()=> reset()}	/>
							</FlexItem>
							<FlexItem className="button-frame">
								<Button	icon="desktop" isPressed={breakPoint === 0}	onClick={() => setBreakPoint(0)} label=">1024px" />
								<Button icon="tablet"	isPressed={breakPoint === 1} onClick={() => setBreakPoint(1)}	label="≥782px" />
								<Button	icon="smartphone"	isPressed={breakPoint === 2} onClick={() => setBreakPoint(2)}	label="<782px"/>
								<Button	icon="editor-contract"	isPressed={breakPoint === 3} onClick={() => setBreakPoint(3)}	label="<600px"/>
							</FlexItem>
						</Flex>		


						<RangeControl
							label={__(`columnsList[${breakPoint}]-gap=1rem`, 'aver')}
							onChange={(newval) =>
								setAttributes({ acolumns: {...acolumns, columnsList: updateArray(columnsList, breakPoint, newval)}})
							}									
							min={1}
						  max={isStackedOnMobile && breakPoint>2 ? 2 : 6}
						
							value={columnsList[breakPoint]}
							__nextHasNoMarginBottom={true}
						/>
			
					
						{/* <RangeControl
							label={__('Desktop >1024px', 'aver')}
							value={columnsList[0]}
							min={1}
							max={6}							
							onChange={(newval) => setAttributes({ acolumns: {...acolumns, columnsList: updateArray( columnsList, 0, newval ) }})}
						/>
						<RangeControl
							label={__('Tablet 782px~1024px', 'aver')}
							value={columnsList[1]}
							min={1}
							max={4}
							//onChange={ ( newval )=> { setAttributes( { columnsList: updateArray( columnsList, 1, newval ) } )	}} 
							onChange={(newval) => setAttributes({ acolumns: {...acolumns, columnsList: updateArray( columnsList, 1, newval ) }})}
						/>
						<RangeControl
							label={__('Mobile 600px~782px', 'aver')}
							value={isStackedOnMobile ? 1 : columnsList[2]}
							min={1}
							max={isStackedOnMobile ? 1 : 2}
							disabled={isStackedOnMobile}
							onChange={(newval) =>
								setAttributes({
									acolumns: {
										...acolumns,
										columnsList: updateArray(columnsList, 2, newval),
									},
								})
							}
						/>

						<RangeControl
							label={__('Small <600px', 'aver')}
							value={isStackedOnMobile ? 1 : columnsList[3]}
							min={1}
							max={isStackedOnMobile ? 1 : 2}
							disabled={isStackedOnMobile}
							onChange={(newval) =>
								setAttributes({
									acolumns: {
										...acolumns,
										columnsList: updateArray(columnsList, 3, newval),
									},
								})
							}
						/> */}


						</>}
						
					</PanelBody>
				
				
			</InspectorControls> 
		</>
	);

}



const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {

	if (!allowedBlocks.includes(props.name)) {
		return <BlockListBlock {...props} />;
	}

	const { attributes, wrapperProps, className } = props;
	const orgDefaults = {
		...acolumnsDefaults,
		...(attributes.acolumns || {}),
	}

	const { 
		aOn, 
		columnsList
	} = orgDefaults;

	
	if (!aOn) {
		return <BlockListBlock {...props} />;
	}

	const breakpointClasses = ['lg', 'md', 'sm', 'ssm'];

	const responsiveClasses = columnsList
		.map((val, index) => (val ? `col-${breakpointClasses[index]}-${val}` : null))
		.filter(Boolean); // removing any falsy values from the array

	const classes = classnames(className, ...responsiveClasses);

	return (
		<BlockListBlock
			{...props}
			wrapperProps={{ style: { ...wrapperProps?.style } }}
			className={classes}
		/>
	)

}



addFilter(
	'blocks.registerBlockType',
	'aver/aver-columns-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/aver-columns-advanced-control',
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock',
	'aver/aver-columns-editor-class',
	applyExtraClassEditor,
);

